/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: dashboard-core
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'./OpenActionHandler'
], function (BaseClass) {
	class ActionHandler extends BaseClass {
		canExecute(options) {
			const isDashboardTemplatesEnabled = !options.glassContext.getCoreSvc('.FeatureChecker').checkValue('dashboard', 'dashboardTemplates', 'disabled');
			return isDashboardTemplatesEnabled && super.canExecute(options);
		}

		_getTargetPerspective() {
			return Promise.resolve('dashboardTemplate');
		}

		_hasValidTags(item) {
			const tags = item.tags || [];
			return tags.includes('dashboard_template');
		}
	}
	return ActionHandler;
});
